<template>
    <div class="m-page">
        <!-- 顶部渐变 hero：标题 + 概览统计 -->
        <div class="m-page__hero" v-if="showHero">
            <div class="m-page__hero-bg"></div>
            <div class="m-page__hero-title">{{ title }}</div>
            <div class="m-page__hero-sub" v-if="subtitle">{{ subtitle }}</div>
            <div
                class="m-page__stats"
                v-if="stats && stats.length"
                :style="{ gridTemplateColumns: 'repeat(' + statColumns + ', 1fr)' }"
            >
                <div class="m-page__stat" v-for="(s, i) in stats" :key="i">
                    <div class="m-page__stat-num" :class="{ 'is-money': s.money }">
                        <template v-if="s.money">¥{{ money(s.value) }}</template>
                        <template v-else>{{ s.value === undefined || s.value === null ? 0 : s.value }}</template>
                    </div>
                    <div class="m-page__stat-lbl">{{ s.label }}</div>
                </div>
            </div>
            <!-- hero 区域自定义内容（如搜索框） -->
            <slot name="hero"></slot>
        </div>

        <!-- 搜索 / 筛选区 -->
        <div class="m-page__search" v-if="$slots.search">
            <slot name="search"></slot>
        </div>

        <!-- 主体内容 -->
        <div class="m-page__body">
            <slot></slot>
        </div>

        <!-- 底部固定区（分页 / 批量操作条） -->
        <div class="m-page__footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { formatMoney } from '@/libs/mobile';

/**
 * m-page —— 手机端页面外壳
 * 提供统一的渐变 hero 头部、统计格子、搜索区、内容区、底部区。
 */
export default {
    name: 'MPage',
    props: {
        title: { type: String, default: '' },
        subtitle: { type: String, default: '' },
        // [{ label: '总数', value: 12, money: false }]
        stats: { type: Array, default: () => [] },
        showHero: { type: Boolean, default: true },
    },
    computed: {
        statColumns() {
            const n = (this.stats || []).length;
            if (n <= 0) return 1;
            if (n === 1) return 1;
            if (n === 2) return 2;
            if (n === 3) return 3;
            return 4;
        },
    },
    methods: {
        money: formatMoney,
    },
};
</script>
